/**
 * Converte uma string de data (ex: '2025-12-08') para o formato brasileiro (DD/MM/AAAA).
 * @param dateString A string de data a ser formatada.
 * @returns A data formatada ou 'Data Inválida'.
 */
export const formatDateToBrazil = (dateString: string): string => {
  if (!dateString) return '';

  // Cria um objeto Date. Ele tentará interpretar fusos horários, mas para strings AAAA-MM-DD
  // se comporta de forma consistente se não for especificado o fuso.
  const date = new Date(dateString);

  // Garante que a data é válida
  if (isNaN(date.getTime())) {
    return 'Data Inválida';
  }

  // Usa o localizador do JavaScript para formatar para o padrão brasileiro
  // 'pt-BR' força o formato DD/MM/AAAA.
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

/**
 * Converte uma string de data (ex: '2025-12-08') para o formato americano (MM/DD/AAAA).
 * @param dateString A string de data a ser formatada.
 * @returns A data formatada ou 'Invalid Date'.
 */
export const formatDateToEua = (dateString: string): string => {
  if (!dateString) return '';

  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }

  // Usa o localizador do JavaScript para formatar para o padrão americano
  // 'en-US' força o formato MM/DD/AAAA.
  const dataFormatted = date.toLocaleDateString('en-US', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

  return dataFormatted;
};

/**
 * Retorna a data no formato ISO (AAAA-MM-DD) usando o fuso horário local.
 * Esta é a forma mais segura de obter o formato AAAA-MM-DD sem offset de UTC.
 * @param dateString A string de data de entrada (ou usa a data atual se for omitida).
 * @returns A data formatada (AAAA-MM-DD) ou 'Data Inválida'.
 */
export const formatDateToIsoLocal = (
  dateString: string | Date = new Date()
): string => {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return 'Data Inválida';
  }

  // Usa os métodos LOCALES (getFullYear, getMonth, getDate)
  const year = date.getFullYear();
  // Mês é 0-indexado, então adicionamos +1 e garantimos 2 dígitos
  const month = String(date.getMonth() + 1).padStart(2, '0');
  // Garante 2 dígitos para o dia
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

